/**
 * Operate with keyboard.
 *
 * @module keyboard
 */

'use strict';


/**
 * Open keyboard through core intent.
 *
 * @param {Object} config - keyboard config
 * @param {Function} [callback] - invoked on successful result
 */
exports.open = function ( config, callback ) {
    core.intent({
        action: 'keyboard',
        data: {
            type:  config.type,
            mode:  config.mode,
            title: config.title,
            value: config.value
        },
        events: {
            done: function ( event ) {
                if ( callback ) {
                    callback(event);
                }
            }
        }
    }, function ( error ) {
        console.log(error);
    });
};
